import axios from 'axios'
// Element UI 引入
import { ElLoading,ElMessage } from 'element-plus'
import router from '@/router';
// axios 配置代码 

const AUTH_TOKEN = ''
// const baseURL =   "http://120.26.215.58:3000/" 
// const baseURL =   "" 
// axios.defaults.baseURL =   baseURL // 基路径   反向代理是不能使用基路径 
axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;  // 请求头 设置token 
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';   // 设置POST请求数据提交方式



let loading = null;

export function showLoading(msg='加载中...'){
    loading&&loading.close(); //
    loading = ElLoading.service({
        lock: true,
        text: msg,
        background: 'rgba(0, 0, 0, 0.7)',
    })
}

export function showSuccess(msg='成功'){
    loading&&loading.close();
    ElMessage.closeAll()
    ElMessage.success(msg);
}

export function showFail(msg='失败'){
    loading&&loading.close();
    ElMessage.closeAll()
    // ElMessage.error(msg);
}


axios.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token') || '';
    config.headers.Authorization = token ? `Bearer ${token}` : '';  // 添加Bearer前缀
    showLoading()
    return config;
}, function (error) {
    console.log(error)
    showFail('请求失败')
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    console.log(response.data)
    if(response.data.code==200){
        showSuccess(response.data.msg)
    }else{
        if(response.data.code==3000){
            router.push({name:'login'})
        }
        showFail(response.data.msg)
    }
    return response;
  }, function (error) {
    console.log(error)
    showFail('服务器异常')
    // router.push('/NOTFOUND')
    return Promise.reject(error);
});


// 增删改查  Promise 
// get
export function get(url,params,headers){
    return new Promise(function(resolve,reject){
        axios({
            url,
            method:"GET",
            params:params,  
            headers,
        })
        .then(result=>{
            resolve(result.data)
        })
        .catch(err=>{
            reject(err)
        })
    })
}
// post
export function post(url,data,params,headers){
    return new Promise(function(resolve,reject){
        axios({
            url,
            method:"post",
            params:params,    
            headers:headers,
            data,   // POST 请求提交的数据 
        })
        .then(result=>{
            resolve(result.data)   
        })
        .catch(err=>{
            reject(err)
        })
    })
}
// delete
export function Delete(url,params){
    return new Promise(function(resolve,reject){
        axios({
            url,
            method:"delete",
            params:params,    
        })
        .then(result=>{
            resolve(result.data)   
        })
        .catch(err=>{
            reject(err)
        })
    })
}
// patch
export function Patch(url,data){
    return new Promise(function(resolve,reject){
        axios({
            url,
            method:"patch",
            data
        })
        .then(result=>{
            resolve(result.data)  
        })
        .catch(err=>{
            reject(err)
        })
    })
}



export {
    axios,
    // baseURL
}
